import React from 'react';
import { HeroVariant2 } from '../components/HeroVariant2';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage2() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1501">
      <Navigation data-id="element-1502" />
      <main data-id="element-1503">
        <HeroVariant2 data-id="element-1504" />
        <WhyUs data-id="element-1505" />
        <Services data-id="element-1506" />
        <FAQ data-id="element-1507" />
        <Testimonials data-id="element-1508" />
        <Consultation data-id="element-1509" />
      </main>
      <Footer data-id="element-1510" />
      <CookieBanner data-id="element-1511" />
      <FloatingContact data-id="element-1512" />
    </div>;
}